<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="width: 100%; position: absolute; top: 0; bottom: 0; overflow-y: auto;">
        <van-list
                v-if="messageList.length > 0"
                v-model="loading"
                :immediate-check="false"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <van-swipe-cell
                    v-for="(cell, index) in messageList"
                    :key="index"
                    :name="index"
                    style="margin-bottom: 10px;">
                <van-cell :border="false" is-link @click="gotoDetail(cell)">
                    <div style="display: flex; justify-content: space-between;">
                        <div slot="title" style="display: flex; align-items: center;">
                             <span v-if="cell.status === '0'" style="width: 4px; height: 4px; margin-right: 6px; background-color: #F76C6C; border-radius: 50%;"></span>
                            <span style="font-size: 12px;">{{cell.message}}</span>
                        </div>
                        <div style="min-width: 80px; margin-left: 10px; font-size: 10px;">
                            {{cell.createTime |
                            dateFormat('YYYY-MM-DD HH:mm:ss')}}
                        </div>
                    </div>
                </van-cell>
<!--                <template slot="right">-->
<!--                    <van-button square type="danger" @click="selectDelete(cell.id)">删除</van-button>-->
<!--                </template>-->
            </van-swipe-cell>
        </van-list>
        <div v-else
             style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
            <span style="margin-top: 20px; color: #999999; font-size: 14px;">暂无消息</span>
        </div>
    </van-pull-refresh>
</template>

<script>

    import Vue from 'vue';
    import {List, Dialog, Toast, SwipeCell, Cell, CellGroup, Button, PullRefresh, Image} from 'vant';

    Vue.use(List).use(Dialog).use(Toast).use(SwipeCell).use(Cell).use(CellGroup).use(Button).use(PullRefresh).use(Image);

    export default {
        name: "Messages",
        data(){
            return {
                messageList: [],
                currentPage: 0,
                total: 0,
                pageSize: 10,
                loading: false,
                finished: false,
                isLoading: false,
            }
        },
        created() {
            this.onLoad()
        },
        methods: {
            onLoad() {
                this.currentPage++;
                this.loading = true;
                const vm = this;
                vm.$toast.loading({
                    mask: true,
                    forbidClick: true,
                    message: "加载中..."
                });
                this.$axios.get('/message/list',{params: {
                    page: this.currentPage,
                    size: this.pageSize
                }}).then((res) => {
                    let data = res.data.rows;
                    this.messageList = this.messageList.concat(data)
                    if (data.length < this.pageSize) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.loading = false;
                    vm.$toast.clear();
                }).catch(err => {
                    this.loading = false;
                    vm.$toast.clear();
                });
            },
            onRefresh() {
                this.currentPage = 0;
                this.messageList = [];
                this.onLoad();
            },
            gotoDetail(item) {
                this.$axios.get("/message/read", {params: {id: item.id}}).then((res) => {
                });
                switch (Number(item.messageType)) {
                    case 0:
                        this.$router.push({path: '/rank'})
                        break
                    case 1:
                        this.$router.push({path: '/integral'})
                        break
                    case 2,3,4,5:
                        this.$router.push({path: '/orderList'})
                        break
                    default:
                        this.$router.push({path: '/messageDetail', query: {id: item.id}})
                }
            }
        }
    }
</script>

<style scoped>

</style>
